import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";

export default {
    component: loadingComponent,
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({ title: "Privacy Policy", allMessage, lang, noindex: true, nofollow: true });
    },
};
